module.exports = __webpack_public_path__ + "static/img/mo-xing-zu-zhuang.2763f88.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/mo-xing-zu-zhuang.png
// module id = U/ld
// module chunks = 3